module.exports = {
  text: `Деревня была пуста, а чайки необычайно тихими, и шум моря — единственное, что мы здесь услышали`,
  author: `Отчет о последствиях нападения сахуагинов`,
}
